/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

/**
 * Core scripts.
 */
import '~/core/lazysizes'
import AppHandler from '~/core/app-handler'
import Bugsnag from '~/core/bugsnag'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import EventBus from '~/core/event-bus'
import Query from '~/core/query'
import { Swiper } from 'swiper'

/**
 * Global CANVAS functions.
 */
window.cnvs = window.cnvs || {}
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query) => Query(query)
window.swiper = Swiper

document.addEventListener('DOMContentLoaded', () => {
  const appHandler = AppHandler()
  appHandler.setNodeSelectors()
  appHandler.handleAppSections()

  Bugsnag().init()
  Commands().init()


  Canvas().init()
  appHandler.setNodeSelectors()
  appHandler.handleAppProxy()
  appHandler.resetAppSectionPlacements()
})
